<div class="flex flex-col h-full bg-white overflow-hidden" (mousedown)="onPageMouseDown($event)">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col overflow-hidden">
      @if (searchResults().length > 0) {
      <!-- Sélection parmi plusieurs résultats -->
      <div class="flex items-center justify-between px-5 pt-5 pb-[15px] shrink-0">
        <button type="button" (click)="cancelSelection()"
          class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors bg-white">
          <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
          {{ 'common.back' | translate }}
        </button>
        <span class="fg-noir-1 text-[19px] font-bold text-center">
          {{ 'scan_page.multiple_results_title' | translate }}
        </span>
        <div class="w-[110px]"></div>
      </div>

      <div class="flex-1 overflow-y-auto mx-5 mb-5 flex flex-col gap-[10px]">
        @for (result of searchResults(); track result.id) {
        <div class="bg-white rounded-[5px] h-[98px] flex items-center px-[30px] gap-5 shrink-0">
          <div class="flex-1 min-w-0 flex flex-col gap-1">
            <span class="fg-noir-2 text-[20px] font-semibold leading-tight truncate">
              {{ getCustomerDisplayName(result) }}
            </span>
            @if (result.badge_number) {
            <span class="fg-gris-1 text-[16px] truncate">#{{ result.badge_number }}</span>
            }
          </div>
          <button type="button" (click)="selectCustomer(result)"
            class="bg-vert-1 border border-gris-4 rounded-[5px] h-[58px] px-5 text-white text-[16px] font-semibold whitespace-nowrap shrink-0 cursor-pointer hover:brightness-95 transition-all">
            {{ 'common.select' | translate }}
          </button>
        </div>
        }
      </div>
      } @else {
      <div class="flex-1 flex items-center justify-center">
        <div class="flex flex-col items-center gap-6">
          <!-- Zone scanner -->
          <div
            class="bg-white border-2 border-dashed border-vert-1 rounded-[14px] h-[191px] w-[175px] flex items-center justify-center">
            <div class="flex flex-col items-center gap-2">
              <img src="assets/images/icones/badge-scanner.png" alt="scanner" class="size-[53px] object-contain" />
              <p class="fg-gris-1 text-[11px] text-center leading-[16.5px] p-2">
                {{ 'scan_page.scan_badge' | translate }}
              </p>
            </div>
          </div>

          <!-- Titre -->
          <h2 class="fg-noir-1 text-[19px] font-bold text-center m-0">
            {{ 'scan_page.scan_badge' | translate }}
          </h2>

          <!-- Séparateur -->
          <div class="flex items-center gap-4 w-[320px]">
            <div class="flex-1 h-px bg-gris-1"></div>
            <span class="fg-gris-1 text-[11px] font-bold uppercase">
              {{ 'common.or' | translate }}
            </span>
            <div class="flex-1 h-px bg-gris-1"></div>
          </div>

          <!-- Barre de recherche -->
          <div class="flex h-[58px]">
            <input #searchInput type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearch()"
              (blur)="onSearchInputBlur($event)" placeholder="{{ 'scan_page.search_placeholder' | translate }}"
              class="bg-white border border-gris-3 border-r-0 rounded-l-[5px] px-5 w-[319px] fg-noir-2 text-[16px] outline-none" />
            <button (click)="onSearch()" [disabled]="isLoading()"
              class="relative bg-vert-1 border border-gris-4 rounded-r-[5px] px-5 text-white text-[16px] font-semibold whitespace-nowrap cursor-pointer hover:brightness-95 transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
              <span [class.invisible]="isLoading()">{{ 'common.search' | translate }}</span>
              @if (isLoading()) {
              <div class="absolute inset-0 flex items-center justify-center">
                <app-loader size="w-5 h-5" />
              </div>
              }
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </main>
</div>

@if (showPassageValidatedModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-confirmation class="w-[500px]" [imageUrl]="'assets/images/icones/valid.png'"
    [title]="'scan_page.checkin_validated_title' | translate" [highlightText]="validatedCustomerName()"
    [countdownText]="'modal.validated_order.countdown' | translate: { seconds: 3 }"
    [buttonLabel]="'common.confirm' | translate" (buttonClick)="onModalButtonClick()" />
</div>
}

@if (showMaxOrderExceededModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-max-order-exceeded class="w-[500px]" [title]="'scan_page.max_order_warning.title' | translate"
    [message]="'scan_page.max_order_warning.message' | translate"
    [currentOrdersLabel]="'scan_page.max_order_warning.current_orders_label' | translate"
    [currentOrdersCount]="maxOrderCurrentCount()"
    [maxOrdersLabel]="'scan_page.max_order_warning.max_orders_label' | translate" [maxOrdersCount]="maxOrderLimit()"
    [backToSelectionLabel]="'scan_page.max_order_warning.back_to_selection' | translate"
    [forcePassageLabel]="'scan_page.max_order_warning.continue_label' | translate"
    (backToSelectionClick)="onMaxOrderBackToSelection()" (forcePassageClick)="onMaxOrderContinue()" />
</div>
}